// src/utils/jsx.ts

const SVG_TAG = [
  "svg",
  "circle",
  "rect",
  "path",
  "g",
  "line",
  "polyline",
  "polygon",
  "text",
  "tspan",
  "use",
  "defs",
  "clipPath",
  "mask",
  "pattern",
  "linearGradient",
  "radialGradient",
  "stop",
  "symbol",
  "image",
  "foreignObject",
];

const appendChild = (parent: Element, child: any): void => {
  if (!child) return;
  if (Array.isArray(child)) {
    child.forEach((nestedChild) => appendChild(parent, nestedChild));
    return;
  }
  if (child instanceof Element) {
    parent.appendChild(child);
    return;
  }
  const text = typeof child === "string" || typeof child === "number"
    ? String(child)
    : null;
  if (text !== null) {
    parent.appendChild(document.createTextNode(text));
  }
};

export const createElement = (
  tag: string | ((props: any, ...children: any[]) => any),
  props: string,
  ...children: Element[]
) => {
  if (typeof tag === "function") {
    return tag(props ?? {}, ...children);
  }

  const element = SVG_TAG.includes(tag)
    ? document.createElementNS("http://www.w3.org/2000/svg", tag)
    : document.createElement(tag);

  Object.entries(props || {}).forEach(([name, value]: [string, any]) => {
    if (!name || !value) return;

    if (name.startsWith("on") && name.toLowerCase() in window) {
      element.addEventListener(name.toLowerCase().substring(2), value);
      return;
    }

    element.setAttribute(name, value.toString());
  });

  children.forEach((child) => {
    appendChild(element, child);
  });

  return element;
};

export const createFragment = (...children: any[]) => {
  const frag = document.createDocumentFragment();
  children.forEach((child) => appendChild(frag as unknown as Element, child));
  return frag;
};
